@if (allRowsHaveRequiredError) {
  <app-validator
    [question]="multiMatrixQuestion"
    [validator]="ValidatorType.RequiredSelect"
  />
}
@if (!isMobileView) {
  <div class="w-full matrix-wrapper">
    <div class="matrix-sticky-header" #stickyHeader aria-hidden="true">
      <div class="matrix-sticky-corner"></div>
      <div class="matrix-sticky-clip">
        <div class="matrix-sticky-inner" #stickyInner>
          <table class="table multi-matrix-table-style sticky-header-table">
            <app-multi-matrix-table-head
              [multiMatrixQuestion]="multiMatrixQuestion"
              idPrefix="sticky-"
              class="contents sticky-clone"
            ></app-multi-matrix-table-head>
          </table>
        </div>
      </div>
    </div>
    <div class="table-container" #tableContainer (scroll)="onTableScroll()">
      <table
        class="table mt-8 mb-4 multi-matrix-table-style"
        [style.--header-first-row-height]="headerFirstRowHeight + 'px'"
      >
        <app-multi-matrix-table-head
          [multiMatrixQuestion]="multiMatrixQuestion"
          class="contents"
        ></app-multi-matrix-table-head>
        <tbody>
          @for (
            question of multiMatrixQuestion.columns[0].rows;
            track $index;
            let rowIndex = $index
          ) {
            <tr>
              <th
                class="text-wrap text-center align-middle left-0 pt-1"
                [innerHTML]="question.title | safeHtml"
                scope="row"
                [id]="
                  (question.title | toValidId) + '-' + multiMatrixQuestion.id
                "
              ></th>
              <!-- First column: questions -->
              @if (question.type === "SINGLE_CHOICE") {
                @if (
                  question.presentation === "VERTICAL" ||
                  question.presentation === "HORIZONTAL"
                ) {
                  @for (
                    alternative of question.alternatives;
                    track altIndex;
                    let altIndex = $index
                  ) {
                    <app-single-select-radio-button
                      [question]="question"
                      [alternative]="alternative"
                      [columnTitle]="multiMatrixQuestion.columns[0].title"
                      [control]="form.get(question.id)"
                      [otherControl]="form.get(question.id + '-OTHER')"
                      [inTable]="true"
                      [cellHeaders]="
                        (question.title | toValidId) +
                        '-' +
                        multiMatrixQuestion.id +
                        ' ' +
                        ((multiMatrixQuestion.columns[0].title | toValidId) +
                          '-' +
                          multiMatrixQuestion.id) +
                        ' ' +
                        ((alternative.title | toValidId) +
                          '-' +
                          multiMatrixQuestion.id)
                      "
                      class="contents"
                      parentTableSelector="app-multi-matrix-table"
                    ></app-single-select-radio-button>
                  }
                } @else if (question.presentation === "SLIDER") {
                  <td
                    [attr.colspan]="question.alternatives.length"
                    class="align-middle pr-3"
                  >
                    <app-slider
                      [question]="question"
                      [control]="form.get(question.id)"
                      [inMatrix]="true"
                      [rowTitle]="
                        question.title +
                        ' - ' +
                        multiMatrixQuestion.columns[0].title
                      "
                      class="w-full"
                    ></app-slider>
                  </td>
                } @else if (question.presentation === "DROPDOWN") {
                  <td class="px-2 pb-2 min-w-48 align-middle">
                    <app-single-select-dropdown-input
                      [question]="question"
                      [control]="form.get(question.id)"
                      [otherControl]="form.get(question.id + '-OTHER')"
                      [inTable]="true"
                      [hideError]="allRowsHaveRequiredError"
                    >
                    </app-single-select-dropdown-input>
                  </td>
                }
              } @else if (question.type === "OPENANSWER") {
                <td class="pt-4 pl-2 pr-1 align-middle min-w-48">
                  <app-open-answer-input
                    [customClass]="'h-12'"
                    [control]="form.get(question.id)"
                    [question]="question"
                    [title]="
                      question.title +
                      ' - ' +
                      multiMatrixQuestion.columns[0].title
                    "
                    [hideError]="allRowsHaveRequiredError"
                  >
                  </app-open-answer-input>
                </td>
              } @else if (question.type === "MULTIPLE_CHOICE") {
                <app-multi-select
                  class="contents"
                  [question]="question"
                  [formGroup]="getFormGroup(question.id, form!)"
                  [otherControl]="form.get(question.id + '-OTHER')"
                  [inTable]="true"
                  [columnTitle]="multiMatrixQuestion.columns[0].title"
                  [rowTitle]="
                    (question.title | toValidId) + '-' + multiMatrixQuestion.id
                  "
                  [colGroupTitle]="
                    (multiMatrixQuestion.columns[0].title | toValidId) +
                    '-' +
                    multiMatrixQuestion.id
                  "
                  [columnIdSuffix]="multiMatrixQuestion.id"
                  [parentTableSelector]="'app-multi-matrix-table'"
                ></app-multi-select>
              }
              <!-- Second column: questions -->
              @for (
                secondColumnQuestion of multiMatrixQuestion.columns[1].rows;
                track $index;
                let alternativeIndex = $index
              ) {
                @if (rowIndex === alternativeIndex) {
                  @if (secondColumnQuestion.type === "SINGLE_CHOICE") {
                    @if (
                      secondColumnQuestion.presentation === "VERTICAL" ||
                      secondColumnQuestion.presentation === "HORIZONTAL"
                    ) {
                      @for (
                        secondColumnAlternative of secondColumnQuestion.alternatives;
                        track altIndex;
                        let altIndex = $index
                      ) {
                        <app-single-select-radio-button
                          [question]="secondColumnQuestion"
                          [alternative]="secondColumnAlternative"
                          [columnTitle]="multiMatrixQuestion.columns[1].title"
                          [secondColumnStart]="altIndex === 0"
                          [control]="form.get(secondColumnQuestion.id)"
                          [otherControl]="
                            form.get(secondColumnQuestion.id + '-OTHER')
                          "
                          [inTable]="true"
                          [cellHeaders]="
                            (question.title | toValidId) +
                            '-' +
                            multiMatrixQuestion.id +
                            ' ' +
                            ((multiMatrixQuestion.columns[1].title
                              | toValidId) +
                              '-' +
                              multiMatrixQuestion.id) +
                            ' ' +
                            ((secondColumnAlternative.title | toValidId) +
                              '-' +
                              multiMatrixQuestion.id)
                          "
                          class="contents"
                          parentTableSelector="app-multi-matrix-table"
                        ></app-single-select-radio-button>
                      }
                    } @else if (
                      secondColumnQuestion.presentation === "SLIDER"
                    ) {
                      <td
                        [attr.colspan]="
                          secondColumnQuestion.alternatives.length
                        "
                        class="align-middle second-column-start"
                      >
                        <app-slider
                          [question]="secondColumnQuestion"
                          [control]="form.get(secondColumnQuestion.id)"
                          [inMatrix]="true"
                          [rowTitle]="
                            secondColumnQuestion.title +
                            ' - ' +
                            multiMatrixQuestion.columns[1].title
                          "
                          class="w-full"
                        ></app-slider>
                      </td>
                    } @else if (
                      secondColumnQuestion.presentation === "DROPDOWN"
                    ) {
                      <td
                        class="px-2 pb-2 min-w-48 align-middle second-column-start"
                      >
                        <app-single-select-dropdown-input
                          [question]="secondColumnQuestion"
                          [control]="form.get(secondColumnQuestion.id)"
                          [otherControl]="
                            form.get(secondColumnQuestion.id + '-OTHER')
                          "
                          [inTable]="true"
                          [hideError]="allRowsHaveRequiredError"
                        >
                        </app-single-select-dropdown-input>
                      </td>
                    }
                  } @else if (secondColumnQuestion.type === "OPENANSWER") {
                    <td
                      class="pt-4 px-2 align-middle second-column-start min-w-48"
                    >
                      <app-open-answer-input
                        [customClass]="'h-12'"
                        [control]="form.get(secondColumnQuestion.id)"
                        [question]="secondColumnQuestion"
                        [title]="
                          secondColumnQuestion.title +
                          ' - ' +
                          multiMatrixQuestion.columns[1].title
                        "
                        [hideError]="allRowsHaveRequiredError"
                      >
                      </app-open-answer-input>
                    </td>
                  } @else if (secondColumnQuestion.type === "MULTIPLE_CHOICE") {
                    <app-multi-select
                      class="contents"
                      [question]="secondColumnQuestion"
                      [formGroup]="getFormGroup(secondColumnQuestion.id, form!)"
                      [otherControl]="
                        form.get(secondColumnQuestion.id + '-OTHER')
                      "
                      [inTable]="true"
                      [secondColumnStart]="true"
                      [columnTitle]="multiMatrixQuestion.columns[1].title"
                      [rowTitle]="
                        (question.title | toValidId) +
                        '-' +
                        multiMatrixQuestion.id
                      "
                      [colGroupTitle]="
                        (multiMatrixQuestion.columns[1].title | toValidId) +
                        '-' +
                        multiMatrixQuestion.id
                      "
                      [columnIdSuffix]="multiMatrixQuestion.id"
                      [parentTableSelector]="'app-multi-matrix-table'"
                    ></app-multi-select>
                  }
                }
              }
            </tr>
            <!-- First column: error messages -->
            @if (
              (form.get(question.id)?.hasError("required") ||
                form.get(question.id)?.hasError("atLeastOneRequired")) &&
              form.get(question.id)?.touched &&
              question.type !== "OPENANSWER" &&
              question.presentation !== "DROPDOWN" &&
              !allRowsHaveRequiredError
            ) {
              <app-validator
                [question]="question"
                [validator]="ValidatorType.RequiredSelect"
                [multiMatrixQuestionTitle]="
                  question.title + ' - ' + multiMatrixQuestion.columns[0].title
                "
              />
            }
            <!-- Second column: error messages -->
            @for (
              secondColumnQuestion of multiMatrixQuestion.columns[1].rows;
              track $index;
              let alternativeIndex = $index
            ) {
              @if (
                (form.get(secondColumnQuestion.id)?.hasError("required") ||
                  form
                    .get(secondColumnQuestion.id)!
                    .hasError("atLeastOneRequired")) &&
                form.get(secondColumnQuestion.id)!.touched &&
                alternativeIndex === rowIndex &&
                secondColumnQuestion.type !== "OPENANSWER" &&
                secondColumnQuestion.presentation !== "DROPDOWN" &&
                !allRowsHaveRequiredError
              ) {
                <app-validator
                  [question]="secondColumnQuestion"
                  [validator]="ValidatorType.RequiredSelect"
                  [multiMatrixQuestionTitle]="
                    secondColumnQuestion.title +
                    ' - ' +
                    multiMatrixQuestion.columns[1].title
                  "
                />
              }
            }
          }
        </tbody>
      </table>
    </div>
    @if (hasHorizontalOverflow) {
      <div
        class="custom-scrollbar-track"
        #scrollbarTrack
        [style.margin-left.px]="firstColumnWidth"
        (mousedown)="onScrollbarTrackClick($event)"
      >
        <div
          class="custom-scrollbar-thumb"
          #scrollbarThumb
          [style.width.px]="scrollbarThumbWidth"
          [style.transform]="'translateX(' + scrollbarThumbPosition + 'px)'"
          (mousedown)="onScrollbarThumbMouseDown($event)"
        ></div>
      </div>
    }
  </div>
}
@if (isMobileView) {
  <div class="block" role="radiogroup">
    <!-- First column: questions -->
    @for (
      question of multiMatrixQuestion.columns[0].rows;
      track $index;
      let rowIndex = $index
    ) {
      <h3
        class="font-semibold mt-3"
        [innerHTML]="question.title | safeHtml"
      ></h3>
      <h4
        class="mt-3"
        [innerHTML]="multiMatrixQuestion.columns[0].title | safeHtml"
      ></h4>
      @if (question.type === "SINGLE_CHOICE") {
        @if (
          question.presentation === "VERTICAL" ||
          question.presentation === "HORIZONTAL"
        ) {
          @for (alternative of question.alternatives; track $index) {
            <app-single-select-radio-button
              [question]="question"
              [alternative]="alternative"
              [columnTitle]="multiMatrixQuestion.columns[0].title"
              [control]="form.get(question.id)"
              [otherControl]="form.get(question.id + '-OTHER')"
              class="contents"
            ></app-single-select-radio-button>
          }
        } @else if (question.presentation === "SLIDER") {
          <app-slider
            [question]="question"
            [control]="form.get(question.id)"
            [inMatrix]="true"
            [rowTitle]="
              question.title + ' - ' + multiMatrixQuestion.columns[0].title
            "
            class="w-full"
          ></app-slider>
        } @else if (question.presentation === "DROPDOWN") {
          <div>
            <app-single-select-dropdown-input
              [question]="question"
              [control]="form.get(question.id)"
              [otherControl]="form.get(question.id + '-OTHER')"
              [hideError]="allRowsHaveRequiredError"
            >
            </app-single-select-dropdown-input>
          </div>
        }
      } @else if (question.type === "OPENANSWER") {
        <div class="mx-2">
          <app-open-answer-input
            [control]="form.get(question.id)"
            [question]="question"
            [title]="
              question.title + ' - ' + multiMatrixQuestion.columns[0].title
            "
            [hideError]="allRowsHaveRequiredError"
          ></app-open-answer-input>
        </div>
      } @else if (question.type === "MULTIPLE_CHOICE") {
        <app-multi-select
          class="contents"
          [question]="question"
          [formGroup]="getFormGroup(question.id, form!)"
          [otherControl]="form.get(question.id + '-OTHER')"
          [inMobileAndMatrix]="true"
          [columnTitle]="multiMatrixQuestion.columns[0].title"
        ></app-multi-select>
      }
      <!-- First column: error messages -->
      @if (
        form.get(question.id)!.hasError("required") &&
        form.get(question.id)!.touched &&
        question.type !== "OPENANSWER" &&
        question.presentation !== "DROPDOWN" &&
        !allRowsHaveRequiredError
      ) {
        <app-validator
          [question]="question"
          [validator]="ValidatorType.RequiredSelect"
          [multiMatrixQuestionTitle]="
            question.title + ' - ' + multiMatrixQuestion.columns[0].title
          "
        />
      }
      <!-- Second column: questions -->
      <h4
        class="mt-3"
        [innerHTML]="multiMatrixQuestion.columns[1].title | safeHtml"
      ></h4>
      @for (
        secondColumnQuestion of multiMatrixQuestion.columns[1].rows;
        track $index;
        let alternativeIndex = $index
      ) {
        @if (rowIndex === alternativeIndex) {
          @if (secondColumnQuestion.type === "SINGLE_CHOICE") {
            @if (
              secondColumnQuestion.presentation === "VERTICAL" ||
              secondColumnQuestion.presentation === "HORIZONTAL"
            ) {
              @for (
                secondColumnAlternative of secondColumnQuestion.alternatives;
                track $index
              ) {
                <app-single-select-radio-button
                  [question]="secondColumnQuestion"
                  [alternative]="secondColumnAlternative"
                  [columnTitle]="multiMatrixQuestion.columns[1].title"
                  [control]="form.get(secondColumnQuestion.id)"
                  [otherControl]="form.get(secondColumnQuestion.id + '-OTHER')"
                  class="contents"
                ></app-single-select-radio-button>
              }
            } @else if (secondColumnQuestion.presentation === "SLIDER") {
              <app-slider
                [question]="secondColumnQuestion"
                [control]="form.get(secondColumnQuestion.id)"
                [inMatrix]="true"
                [rowTitle]="
                  secondColumnQuestion.title +
                  ' - ' +
                  multiMatrixQuestion.columns[1].title
                "
                class="w-full"
              ></app-slider>
            } @else if (secondColumnQuestion.presentation === "DROPDOWN") {
              <div>
                <app-single-select-dropdown-input
                  [question]="secondColumnQuestion"
                  [control]="form.get(secondColumnQuestion.id)"
                  [otherControl]="form.get(secondColumnQuestion.id + '-OTHER')"
                  [hideError]="allRowsHaveRequiredError"
                >
                </app-single-select-dropdown-input>
              </div>
            }
          } @else if (secondColumnQuestion.type === "OPENANSWER") {
            <div class="pt-3 align-middle mx-2">
              <app-open-answer-input
                [control]="form.get(secondColumnQuestion.id)"
                [question]="secondColumnQuestion"
                [title]="
                  secondColumnQuestion.title +
                  ' - ' +
                  multiMatrixQuestion.columns[1].title
                "
                [hideError]="allRowsHaveRequiredError"
              ></app-open-answer-input>
            </div>
          } @else if (secondColumnQuestion.type === "MULTIPLE_CHOICE") {
            <app-multi-select
              class="contents"
              [question]="secondColumnQuestion"
              [formGroup]="getFormGroup(secondColumnQuestion.id, form!)"
              [otherControl]="form.get(secondColumnQuestion.id + '-OTHER')"
              [inMobileAndMatrix]="true"
              [columnTitle]="multiMatrixQuestion.columns[1].title"
            ></app-multi-select>
          }
        }
      }
      <!-- Second column: error messages -->
      @for (
        secondColumnQuestion of multiMatrixQuestion.columns[1].rows;
        track $index;
        let alternativeIndex = $index
      ) {
        @if (
          form.get(secondColumnQuestion.id)!.hasError("required") &&
          form.get(secondColumnQuestion.id)!.touched &&
          alternativeIndex === rowIndex &&
          secondColumnQuestion.type !== "OPENANSWER" &&
          secondColumnQuestion.presentation !== "DROPDOWN" &&
          !allRowsHaveRequiredError
        ) {
          <app-validator
            [question]="secondColumnQuestion"
            [validator]="ValidatorType.RequiredSelect"
            [multiMatrixQuestionTitle]="
              secondColumnQuestion.title +
              ' - ' +
              multiMatrixQuestion.columns[1].title
            "
          />
        }
      }
    }
  </div>
}
